import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import {
  AdvancedSearchDialogComponent,
  AdvancedSearchDialogConfig,
} from './advanced-search-dialog.component';

@Injectable()
export class AdvancedSearchService {
  constructor(private _dialog: MatDialog) {}

  open(data: AdvancedSearchDialogConfig) {
    const ref = this._dialog.open(AdvancedSearchDialogComponent, {
      data,
      closeOnNavigation: true,
      width: '80vw',
      height: '77vh',
      panelClass: 'advanced-search-dialog-panel',
    });

    return ref.afterClosed();
  }
}
